var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "col" }, [
    _c("img", {
      staticClass: "img-rounded lazy",
      attrs: { src: _vm.photo.url, alt: "" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }